import React from 'react'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import styled from 'styled-components'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
import Button from 'components/UI/Button/Button'

export const Title = styled.div`
  color: ${colors.pink};
  font-size: 28px;
  text-align: center;
`

export const Content = styled.div`
  text-align: center;
  padding: 50px 0;
`

export const Info = styled.div`
  color: ${colors.pink};
  text-align: center;
  font-size: 14px;
  padding: 0 20px;
`

export const BottomInfo = styled.div`
  color: ${colors.darkTeal};
  font-size: 11px;
  a {
    color: ${colors.darkPurple};
  }
`

class InvoiceSuccessPopup extends React.Component {
  render () {
    return <DashboardPopup
      onCancel={this.props.onCancel}
    >
      <Title>
        Thank you!
      </Title>
      <Info>
        A member of our team will be in touch within 24 hours.
      </Info>
      <Content>
        <Button onClick={() => this.props.redirectTo('/dashboard/classroom')}>Back to homepage</Button>
      </Content>
      <BottomInfo>
      Any questions? Simply email <a href='mailto:sales@nightzookeeper.com'>sales@nightzookeeper.com</a> or click on the chat icon at the bottom right of the screen.
      </BottomInfo>
    </DashboardPopup>
  }
}

export default (props) => {
  const router = useRouter()
  return <InvoiceSuccessPopup {...props} redirectTo={router.push} />
}

